import Vue from 'vue'
import axios from 'axios';
import _ from 'lodash';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Object.defineProperty(Vue.prototype, '$http', { value: axios });
Object.defineProperty(Vue.prototype, '_', { value: _ });

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
